import { render, staticRenderFns } from "./SPCompanyCertifications.vue?vue&type=template&id=f201eac8&scoped=true"
import script from "./SPCompanyCertifications.vue?vue&type=script&lang=js"
export * from "./SPCompanyCertifications.vue?vue&type=script&lang=js"
import style0 from "./SPCompanyCertifications.vue?vue&type=style&index=0&id=f201eac8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f201eac8",
  null
  
)

export default component.exports